<script setup>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
</script>

<template>
<Popover as="span" class="relative" v-slot="{ open, close }">
    <transition
        enter-active-class="transition ease-out"
        enter-from-class="transform opacity-0 translate-y-2"
        leave-active-class="transition ease-out"
        leave-to-class="transform opacity-0 translate-y-2"
    >
        <PopoverPanel class="absolute z-10 bottom-10 left-1/2 -translate-x-1/2 text-center xl:w-max">
            <slot name="popover" />
        </PopoverPanel>
    </transition>
    <PopoverButton class="!cursor-default focus:outline-none inline-block" v-on:mouseenter="$event.target.click()" v-on:mouseleave="close">
        <slot />
    </PopoverButton>
</Popover>
</template>
